import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const uploadImg = async (data) => {
  try {
    const response = await axios.post(
      `${base_url}upload/create`,
      data,
      {
        ...config,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 600000,
      }
    );
    // server may return {status:'error',message:...} even with 200
    if (response.data && response.data.status === 'error') {
      throw new Error(response.data.message || 'Upload failed');
    }
    return response.data;
  } catch (error) {
      let message = 'Upload failed';
      // network-level errors (e.g. DNS) may not have response
      if (error.code === 'EAI_AGAIN' || error.message?.includes('getaddrinfo')) {
        message = 'Network/DNS error while contacting Cloudinary. Check your internet connection.';
        console.error('Network DNS error:', error.message);
      } else if (error.response && error.response.data) {
        // cloudinary or server returned structured error
        message = error.response.data.message || JSON.stringify(error.response.data);
        console.error('Server Error:', error.response.data);
      } else if (error.request) {
        message = 'No response from server or timeout';
        console.error('Network Error or Timeout:', error.message);
      } else {
        message = error.message;
      }
      // wrap in Error for thunk to pick up
      throw new Error(message);
    }
};

const deleteImg = async (id) => {
  try {
    const response = await axios.delete(
      `${base_url}upload/delete-img/${id}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting image:", error.message);
    throw error;
  }
};

const uploadService = {
  uploadImg,
  deleteImg,
};

export default uploadService;
